module.exports = __webpack_public_path__ + "static/media/Xeirokrotima_3.94ac6345.jpg";